const addlistfrom = [
  // {
  //   inputdata: "",
  //   title: "仓库",
  //   fontSize: "14px",
  //   color: "#333333",
  //   placeholder: "全部",
  //   types: "",
  //   inputtype: "select",
  //   width: "240px",
  //   btx: true,
  //   lablewith: "50px",
  //   options: [],
  // },

  {
    inputdata: "",
    title: "商品代码",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "180px",
    lablewith: "110px",
  },
  {
    inputdata: "",
    title: "批号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "180px",
    lablewith: "110px",
  },
];
export default addlistfrom;
